import "./bootstrap";

import.meta.glob("../images/**", { eager: true });

import { Alpine } from "livewire";

const { data } = Alpine;

data("websiteUrl", () => ({
  launch: false,
  websiteUrl: sessionStorage.getItem("website_url") ?? "",
  setWebsiteUrl(url: string) {
    this.websiteUrl = url;
    sessionStorage.setItem("website_url", url);
    window.location.href = "/register";
  },
}));

data("registrationForm", () => ({
  currentStep: 1,
  formData: {
    website_url: sessionStorage.getItem("website_url") ?? "",
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    terms: false,
  },
  errors: {
    website_url: "",
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    terms: "",
  },
  init() {
    if (sessionStorage.getItem("website_url")) {
      this.formData.website_url = sessionStorage.getItem("website_url") ?? "";
      this.currentStep = 2;
    }

    // Hydrate from any existing inputs rendered by Blade (e.g., old() values)
    const getValue = (selector: string): string => {
      const el = document.querySelector<HTMLInputElement>(selector);
      return el?.value ?? "";
    };

    const websiteUrl = getValue('input[name="website_url"]');
    const name = getValue('input[name="name"]');
    const email = getValue('input[name="email"]');
    const password = getValue('input[name="password"]');
    const passwordConfirmation = getValue('input[name="password_confirmation"]');
    const termsEl = document.querySelector<HTMLInputElement>('input[name="terms"]');

    // Only overwrite website_url from DOM if it has a value, otherwise preserve sessionStorage value
    this.formData.website_url = websiteUrl || this.formData.website_url;
    this.formData.name = name;
    this.formData.email = email;
    this.formData.password = password;
    this.formData.password_confirmation = passwordConfirmation;
    this.formData.terms = termsEl ? !!termsEl.checked || termsEl.value === "1" : false;

    // If we already have personal info, jump to the appropriate step
    if (this.formData.name || this.formData.email) {
      this.currentStep = 2;
    }
  },
  nextStep() {
    if (this.validateCurrentStep()) {
      if (this.currentStep < 4) this.currentStep++;
    }
  },
  previousStep() {
    if (this.currentStep > 1) this.currentStep--;
  },
  validateCurrentStep(): boolean {
    // Clear previous inline errors for current step
    const clearErrors = (fields: (keyof typeof this.errors)[]) => fields.forEach((f) => (this.errors[f] = ""));

    if (this.currentStep === 1) {
      // Website URL optional; allow proceed
      return true;
    }
    if (this.currentStep === 2) {
      clearErrors(["name", "email", "password", "password_confirmation"]);

      let ok = true;
      if (!this.formData.name) {
        this.errors.name = "Name is required.";
        ok = false;
      }
      if (!this.formData.email) {
        this.errors.email = "Email is required.";
        ok = false;
      }
      if (!this.formData.password) {
        this.errors.password = "Password is required.";
        ok = false;
      }
      if (this.formData.password && this.formData.password.length < 8) {
        this.errors.password = "Password must be at least 8 characters.";
        ok = false;
      }
      if (this.formData.password !== this.formData.password_confirmation) {
        this.errors.password_confirmation = "Passwords do not match.";
        ok = false;
      }
      if (!ok) return false;
    }
    if (this.currentStep === 4) {
      const termsInput = document.querySelector<HTMLInputElement>('input[name="terms"]');
      this.errors.terms = "";
      if (termsInput && !this.formData.terms && !termsInput.checked) {
        this.errors.terms = "Please accept the terms and privacy policy to continue.";
        return false;
      }
    }
    return true;
  },
  handleSubmit(event: SubmitEvent) {
    event.preventDefault();
    if (!this.validateCurrentStep()) return;

    const form = event.target as HTMLFormElement;

    // Ensure hidden inputs are in sync before submit
    const setIfExists = (name: string, value: string | boolean) => {
      const input = form.querySelector<HTMLInputElement>(`input[name="${name}"]`);
      if (input) {
        if (input.type === "checkbox") {
          input.checked = Boolean(value);
        } else {
          input.value = String(value ?? "");
        }
      }
    };

    setIfExists("website_url", this.formData.website_url);
    setIfExists("name", this.formData.name);
    setIfExists("email", this.formData.email);
    setIfExists("password", this.formData.password);
    setIfExists("password_confirmation", this.formData.password_confirmation);
    setIfExists("terms", this.formData.terms);

    form.submit();
  },
}));
